import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "283",
  "slug": "spot-china-from-satellite-imagery",
  "title": "How to Recognise China in Satellite Images",
  "excerpt": "China includes the Tibetan Plateau in the southwest, dry inland basins farther north, and extensive settled plains in the east.",
  "date": "2026-05-17",
  "category": "Geography",
  "series": "Spot the Country",
  "image": "/blog-images/china.jpg",
  "readTime": "1 min",
  "content": [
    {
      "type": "paragraph",
      "text": "China includes the Tibetan Plateau in the southwest, dry inland basins farther north, and extensive settled plains in the east. The Yangtze and Yellow River systems give a wide view more structure than a patch of farmland can. The southern coast has a different outline and terrain from the northeast."
    },
    {
      "type": "heading",
      "text": "High western terrain and eastern plains"
    },
    {
      "type": "paragraph",
      "text": "Find the transition from the Tibetan Plateau towards lower land to the east. Compare a mountain valley with a plain rather than assuming both should share one visual pattern."
    },
    {
      "type": "heading",
      "text": "Similar landscapes across borders"
    },
    {
      "type": "paragraph",
      "text": "Terraces, dense cities, and rice fields occur elsewhere in Asia. An image of a settlement does not reveal a national identity by itself. Compare the shape of the surrounding basin and its river outlets."
    }
  ],
  "imageAlt": "China regional satellite composite with shaded relief",
  "imageCaption": "NASA Earth Observatory / MODIS, August 2004. Regional composite with shaded relief and bathymetry; it shows landforms, not political boundaries or current conditions.",
  "sources": [
    {
      "title": "NASA: Blue Marble Next Generation (image source)",
      "url": "https://science.nasa.gov/earth/earth-observatory/blue-marble-next-generation/"
    }
  ]
};
